export const auOnBoardingConstants = {
  //todo: make the country name dynamic based on the current country. Very important
  // for now, Australia is fine, but change it
  ADDRESS_VERIFICATION_HEADING: 'Address verification',
  ID_VERIFICATION_HEADING: 'Identity verification',
  ADDRESS_VERIFICATION_DESC:
    "Whoops! We seem to have hit a snag. We weren't able to verify your address. " +
    'Please upload one of the following documents so we can proceed.',
  ID_VERIFICATION_DESC:
    "Whoops! We seem to have hit a snag. We weren't able to verify your identity. " +
    'Please upload one of the following documents so we can proceed.',

  BANK_METHOD_HEADING: 'Bank statement',
  UTILITY_BILL_HEADING: 'Utility bill',
  DRIVING_LICENSE_HEADING: 'Australia driver’s license',
  OTP_HEADING: 'OTP verification',
  OTP_INIT_DESC: 'We will be sending a 6-digit code to your registered mobile number.',
  OTP_SENT_DESC: 'We have sent a 6-digit code to your registered mobile number.',
  OTP_NOT_RECEIVED: 'I didn’t get the verification code',
  RESEND_OTP: 'Resend verification code',

  PERSONAL_DETAILS: 'Personal details',
  PASSPORT_DETAILS: 'Passport details',
  IDENTITY_CHECK_HEADING: 'Identity check',
  IDENTITY_CHECK_SUB_HEADING: `Grab your ID documents and find the best lighting to click a
  picture. For a smooth experience, make sure you follow the instructions carefully.`,
  SCAN_ID_DOCUMENT: `Scan ID document`,
  ENTER_DETAILS_MANUALLY: `Enter details manually`,
  ID_VERIFICATION_FAIL_HEADING: 'Automated verification failed',
  ID_VERIFICATION_FAIL_DESC: 'Unfortunately we hit a glitch. Please fill in the below manually.',

  CONFIRM_DETAILS: 'Confirm details',
  EDIT_DETAILS: 'Edit details',

  USER_CONSENT: `By proceeding you consent to Instarem disclosing above information to the required
  and applicable data sources and the government agency to verify your identity as per
  Instarem’s Privacy Policy and its Terms & Conditions.`
};

export const OCR_VERIFICATION = 'ocr_verification';
export const PERSONAL_INFORMATION = 'personal_information_input';
export const RETRIEVE_INFO_CONSTANT = {
  HEADING: 'Retrieved information',
  SUB_HEADING: `Review the information that we retrieved from your passport to make sure it's accurate`,
  PERSONAL_DETAILS_SECTION: 'Personal details',
  FULL_NAME: 'Full name:',
  FIRST_NAME: 'First name:',
  LAST_NAME: 'Last name:',
  MIDDLE_NAME: 'Middle name:',
  DATE_OF_BIRTH: 'Date of birth:',
  NATIONALITY: 'Nationality:',
  NUMBER: 'Number:',
  EXP_DATE: 'Expiry date:',
  ISSUING_COUNTRY: 'Issuing country:',
  USER_CONSENT: `By proceeding you consent to Instarem disclosing above information to the required
  and applicable data sources and the government agency to verify your identity as per
  Instarem’s Privacy Policy and its Terms & Conditions.`,
  CONFIRM_DETAILS: 'Confirm details',
  CONFIRM: 'Confirm',
  SELECT: 'Select',
  EDIT_DETAILS: 'Edit details',
  DRIVERS_LICENSE: 'Australia driver’s license details',
  PASSPORT: 'Australia passport details',
  SELECT_NATIONALITY: 'Select your nationality',
  DRIVING_LICENSE_ISSUER: `Select who issued your driver’s license`,
  COMPLETE_DETAILS: 'Please complete all the details to proceed.',
  GOT_IT: 'Got it',
  ISSUED_BY: 'Issued by:',
  DRIVING_LICENSE_DOCUMENT: 'DRIVING_LICENSE'
};

export const PERSONAL_INFORMATION_TEXT = {
  PERSONAL_DETAILS: 'Personal details',
  PERSONAL_INFORMATION_HEADING: 'Personal information',
  PERSONAL_INFORMATION_SUBHEADING: `To comply with regulations, we need you to share some of your personal details. Make sure they are 
  accurate and match your ID documents.`,
  PERSONAL_INFORMATION_EDIT_HEADING: 'Edit your information',
  PERSONAL_INFORMATION_EDIT_SUBHEADING: `Edit your details below and review to make sure all is accurate.`,
  NEXT: 'Next',
  CONSENT: `By proceeding you consent to Instarem disclosing above information to the required
  and applicable data sources and the government agency to verify your identity as per
  Instarem’s Privacy Policy and its Terms & Conditions.`
};

export const DOCUMENTS_INFORMATION_TEXT = {
  DOCUMENT_INFORMATION_HEADING: 'Document information',
  DOCUMENT_INFORMATION_SUB_HEADING: `To complete setting up your Instarem account, we need a
   little more information from you. Share the details below to help us verify your identity.`,
  AUTO_APPROVED:
    'You can provide both documents to get the highest chance for being auto approved.',
  SELECT_ONE_DOCUMENT: 'You must select at least one document for submission.',
  NEXT: 'Next',
  PASSPORT_DETAILS: 'Passport details',
  HIGH_AUTO_APPROVAL_RATE: 'High auto approval rate',
  DRIVING_LICENSE: 'Australia driver’s license',
  MODERATE_APPROVAL_RATE: 'Moderate auto approval rate',
  GOT_IT: 'Got it',
  CARD_NUMBER_TOOLTIP: `The card number is a unique number added to a new version of driver license in Australia. 
  The position of the card number for each State and Territory can be different.`,
  LICENSE_NUMBER_TOOLTIP: `The license number is a unique number located on the front of your driver license.`
};

export const EDIT_PERSONAL_INFORMATION = {
  HEADING: 'Edit your information',
  SUB_HEADING: 'Edit your details below and review to make sure all is accurate.',
  PERSONAL_DETAILS: 'Personal details',
  NEXT: 'Next',
  CONSENT: `By proceeding you consent to Instarem disclosing above information to the required
 and applicable data sources and the government agency to verify your identity as per
 Instarem’s Privacy Policy and its Terms & Conditions.`,
  DRIVERS_LICENSE: 'Australia driver’s license details',
  PASSPORT_DETAILS: 'Passport details',
  DRIVERS_LICENSE_NUMBER: 'Driver’s license number',
  PASSPORT_NUMBER: `Passport number`,
  CARD_NUMBER_TOOLTIP: `The card number is a unique number added to a new version of driver license in Australia. 
  The position of the card number for each State and Territory can be different.`,
  LICENSE_NUMBER_TOOLTIP: `The license number is a unique number located on the front of your driver license.`
};

export const SUCCESS_PAGE = {
  ALL_SET: 'You’re all set!',
  START_SENDING: 'Start sending money to your friends and family straight away.',
  GO_TO_HOME: 'Go to home',
  GO_TO_HOME_SCREEN: 'Go to home screen',
  YOU_EARNED: 'You earned',
  INSTA_POINTS_EXPIRY_DATES:
    'Your InstaPoints may have different expiration dates. Check your profile for full information.',
  INSTA_POINTS: 'InstaPoints',
  FIRST_TRANSACTION:
    '100 InstaPoints give you a 2.5 AUD discount when you transfer over 500 AUD. ' +
    'Refer friends to earn more!',
  SUBMITED_SUCCESSFULLY: 'Submitted successfully!',
  PROFILE_IN_REVIEW: 'We are reviewing your profile',
  NOTIFY: 'You’ll be notified once your account is ready. This may take up to 24 hours.',
  SEND_MONEY: 'Send Money',
  HELP_CENTER_TEXT1: 'Need help?',
  HELP_CENTER_TEXT2: 'Visit',
  HELP_CENTER_TEXT3: 'Help Centre'
};
export const OCR = {
  UNABLE_TO_RETRIEVE_INFO: 'We are unable to retrieve your information',
  PROVIDE_DETAILS_MANUALLY: 'Please enter your details manually to proceed with the registration.',
  ENTER_DETAILS_MANUALLY: 'Enter details manually',
  SCAN_ID: 'Scan ID document'
};

export const SELFIE_UPLOAD_PAGE = {
  HEADING: 'Selfie',
  SUB_HEADING: 'You are almost done. Capture a selfie and you are good to go!',
  SUBMIT_BUTTON: 'Submit',
  UPLOAD_SELFIE: 'Capture a selfie',
  CAPTURE_SELFIE:
    'Capture your selfie making sure your full face is visible and there are no blurry areas',
  REPLACE: 'Replace',
  ERR_MSG: 'Required'
};

export const USOnBoardingConstants = {
  ADDRESS_VERIFICATION_HEADING: 'Address verification',
  ADDRESS_VERIFICATION_DESC: 'Upload one of the following documents to verify your address.',
  DRIVING_LICENSE_HEADING: 'US driver’s license'
};
export const EU_UK_OnBoardingConstants = {
  ADDRESS_VERIFICATION_HEADING: 'Upload address document',
  ADDRESS_VERIFICATION_DESC:
    'Upload one of the following: Bank statement, utility bill or letter from government (no older than 3 months)'
};
